import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/_helpers/alert.service';
import { RoutingService } from 'src/app/_services/routing.service';
import { StorageService } from 'src/app/_services/storage.service';

@Component({
  selector: 'app-customers-listing',
  templateUrl: './customers-listing.component.html',
  styleUrls: ['./customers-listing.component.scss']
})
export class CustomersListingComponent implements OnInit {
  customers: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<CustomersListingComponent>,
    private ngZone: NgZone,
    public routing: RoutingService,
    private _alert: AlertService,
    private _formBuilder: FormBuilder,
    public storage: StorageService,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  async ngOnInit() {
    if (this.data) {
      this.customers = this.data.customers;
    }
  }

  closeDialog() {
    this.ngZone.run(() => {
      this.dialogRef.close(this.data.licenceRequest);
    });
  }

}
